
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class AllergyCategory extends Vue {
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: Array, default: () => [] }) readonly allergies!: string[];
  @Prop({ type: String, default: 'None specified' }) readonly emptyText!: string;
  
  get hasAllergies(): boolean {
    return this.allergies && this.allergies.length > 0;
  }
}
